<template>
  <footer id="footer" class="section footer">

    <div class="wrapper-footer">

      <div class="footer-container">
        <p>Pasticcio is a research project by</p>
        <div class="logos">
          <a href="https://www.uw.edu.pl/" target="_blank"><img src="../assets/PI_5_UW_PODSTAWOWY_PL_OKRAG_grey.png" width="100" alt="Uniwersytet Warszawski"></a>
          <a href="https://www.uni-greifswald.de/" target="_blank"><img src="../assets/logoUniGreifswald-Signet2018-grey.png" width="240" alt="Universität Greifswald"></a>
          <a href="https://zenmem.de/" target="_blank"><img src="../assets/ZenMEM_dunkel_grey.png" width="210" alt="Zentrum Musik - Edtition - Medien"></a>
        </div>
      </div>
      <div class="footer-container">
        <p>The project is funded by</p>
        <div class="logos">
          <a href="https://www.ncn.gov.pl/" target="_blank"><img src="../assets/ncn-logo_grey.png" width="180" alt="Narowe Centrum Nauki"></a>
          <a href="http://www.dfg.de/" target="_blank"><img src="../assets/dfg_logo_schriftzug_grey.png" width="248" alt="Deutsche Forschungsgemeinschaft"></a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>
  .footer {
    font-family: 'Lato', sans-serif;
    font-weight:400;
    color:#4e4e4e;
    font-size:16px;
    position: relative;
    background-color:rgb(239,236,236);
    padding:60px 0 60px 0;
    width:100%;
    margin:0 auto;
    box-sizing:border-box;
  }

  .wrapper-footer {
    position:relative;
    margin:0 auto;
    width:1280px;
    box-sizing:border-box;
  }
  .footer-container {
    display:inline-block;
    line-height:24px;
    margin-right:80px;
    vertical-align:top;
  }
  .footer-container p {
    margin-bottom:60px;
  }
  .footer-container:last-child {
    margin-right:0;
  }

  .footer-container .logos a  {
    display:inline-block;
    margin-right:20px;
  }
  .footer-container:nth-child(1) .logos a:nth-child(2)  {
    vertical-align: 26px;
  }
  .footer-container:nth-child(1) .logos a:nth-child(3)  {
    vertical-align: 32px;
  }

  .footer-container:nth-child(2) .logos a:nth-child(1)  {
    margin-top:30px;
  }
  .footer-container:nth-child(2) .logos a:nth-child(1)  {
    vertical-align: -5px;
  }

  @media only screen and (min-width: 1px) and (max-width: 1279px) {

    .wrapper-footer {
      width:100%;
      padding:0 11.6vw;
    }

    .footer-container:last-child {
      margin-top:60px;
    }
    .footer-container p {
      margin-bottom:30px;
    }
    .footer-container:last-child p {
      margin-bottom:0;
    }
  }

  @media only screen and (min-width: 1px) and (max-width: 799px) {
    .wrapper-footer {
      padding: 0 4vw;

    }
    .footer-container {
      display:block;
      margin-right:0;
    }
    .footer-container:nth-child(1) .logos a:nth-child(3)  {
      display:block;
      margin-top:25px;
    }
  }

  @media only screen and (min-width: 1px) and (max-width: 600px) {
    .wrapper-footer {
      padding: 0 4vw;

    }
    .footer-container {
      display:block;
      margin-right:0;
    }
    .footer-container.logos a:nth-child(1),
    .footer-container .logos a:nth-child(2),
    .footer-container .logos a:nth-child(3)  {
      display:block;
      margin-top:25px;
    }
  }
</style>
